const GraduateIcon = () => {
  return (
    <svg viewBox="0 0 18 16.2">
      <g id="surface1" transform="translate(0 -47.367)">
        <path d="M9,47.367a.626.626,0,0,0-.284.07l-8.393,4.2a.6.6,0,0,0,0,1.064l8.388,4.193A.6.6,0,0,0,9,56.967a.6.6,0,0,0,.284-.073L17.672,52.7l.007,0a.6.6,0,0,0,0-1.064L9.288,47.442A.594.594,0,0,0,9,47.367Zm8.4,6.813-1.2.6v5.353a1.2,1.2,0,0,0-.6,1.034,7.928,7.928,0,0,0,1.2,2.4,7.928,7.928,0,0,0,1.2-2.4,1.2,1.2,0,0,0-.6-1.034Zm-13.8,1.5v2.489c0,1.657,2.416,3,5.4,3s5.4-1.343,5.4-3V55.678L9.818,57.97a1.461,1.461,0,0,1-.152.063A1.732,1.732,0,0,1,9,58.167a1.75,1.75,0,0,1-.666-.134,1.24,1.24,0,0,1-.152-.066Z" />
      </g>
    </svg>
  );
};

export default GraduateIcon;
